<template lang="pug">
GenericCard.pending-approval-list(size='auto' h-100)
  .sticky-top.bg-white
    .d-flex.align-items-center.justify-content-between.p-3
      .d-flex
        .text-large รายการรออนุมัติ
        //- LoadingIndicator.ml-2(v-if='isLoading')
      CustomDatePicker(v-model='filterDate')
    hr.m-0


  LoadedContentWrapper.flex-fill(
    :isLoading='isLoading'
    :data='tableData'
    @reload='loadData'
  )
    .pt-2.pb-2.px-3.scrollable.flex-fill
      CustomTable(
        :columns='tableCols'
        :data='filteredTableData'
        :startIndex='pageFirstRowIndex'
        @itemClicked='tableItemClicked'
      )
    .sticky-bottom.bg-white
      hr.m-0
      .px-4.py-3
        CustomPagination(
          v-model='currentPage'
          :total='totalPage'
          :compact='true'
        )
</template>

<script>
/* eslint-disable arrow-body-style */
export default {
  computed: {
    filteredTableData() {
      // if (this.tableData) {
      //   return this.tableData.filter((item) => {
      //     return (this.filterDate === '')
      //       || (this.$dateUtils.isInRange(item.date, this.filterDate));
      //   });
      // }
      // return [];
      return this.tableData;
    },
  },
  watch: {
    // reload data
    filterDate: {
      deep: true,
      handler() { this.loadData(); },
    },
    currentPage() { this.loadData(); },
  },
  data: () => ({
    isLoading: false,

    tableCols: {
      date: {
        title: 'วันที่อนุมัติบิล',
        align: 'center',
        type: Date,
      },
      entryNo: {
        title: 'เลขที่รายการ',
        align: 'left',
        type: 'EntryNo',
      },
      customerZone: {
        title: 'เขต',
        align: 'center',
        computed(row) {
          if (row.customer && row.customer.zone) {
            return row.customer.zone;
          }
          return '-';
        },
      },
      customerName: {
        title: 'ชื่อลูกค้า',
        align: 'left',
        computed(row) {
          if (row.customer && row.customer.name) {
            return row.customer.name;
          }
          return '-';
        },
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        // computed(row) {
        //   if (row.products) {
        //     return row.products.reduce((total, prod) => (total + Number(prod.price)), 0);
        //   }
        //   return 0;
        // },
      },
    },

    tableData: [],
    filterDate: '',

    currentPage: 1,
    totalPage: 0,
    totalRows: 0,
    pageFirstRowIndex: 1,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      try {
        const res = await this.$api.cs.sellRecord.adminApprovalList(
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
        );

        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;

          this.$emit('finishLoading', this.tableData);
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },

    tableItemClicked(e) {
      // const { index, data } = e;
      this.$router.push({
        name: 'admin.pending-approval', // can't use path, cause it WON'T allow passing hidden params
        params: {
          order: e.data,
          // ...e, // pass everything in, LOL
        },
      });
    },
  },
};
</script>

<style lang="scss">
.pending-approval-list {
  .filter-date {
    font-size: 20px;
  }
}
</style>
